import './checkbox-element.scss';

export default {
  fieldset: 'form-group',
  label: 'label-override',
  buttons: '',
  buttonsEmpty: '',
  buttonLabel: 'checkbox-label',
  checkbox: 'checkbox-button',
  readOnly: 'checkbox-button checkbox-readonly',
  requiredIndicator: 'required-indicator',
}
